module.exports = __webpack_public_path__ + "img/local_gas_station.c91281d5.svg";